import { render, staticRenderFns } from "./VirtualCards.vue?vue&type=template&id=26bc36e5&"
import script from "./VirtualCards.vue?vue&type=script&lang=js&"
export * from "./VirtualCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports